import { isNil } from 'lodash';

export const isCarouselCreative = creative => !isNil(creative?.hierarchyRepItemId);
